import { Component, OnInit, OnDestroy, ViewChild, EventEmitter, Output, ɵConsole, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Observable, from, Subscription } from 'rxjs';
import { concatMap, filter, toArray, take, map } from 'rxjs/operators';
import { FacadeSesionService } from 'src/app/services/facade-sesion.service';
import { LevantamientoObraService } from 'src/app/services/levantamiento-obra.service';
import { LevantamientoObra } from 'src/app/models/entities/levantamiento-obra';
import { RutaCatalogoEnum } from 'src/app/shared/enums/ruta-catalogo.enum';
import { CatalogoService } from 'src/app/services/catalogo.service';
import { ElementoCatalogo } from 'src/app/models/entities/elemento-catalogo';
import { Obra } from 'src/app/models/entities/obra';
import { MapUtils } from 'src/app/shared/utils/map-utils';
import { AgmMap, AgmMarker, MapsAPILoader } from '@agm/core';
import { ObraService } from 'src/app/services/obra.service';
import { Estado } from 'src/app/models/entities/estado';
import { ObraDTO } from 'src/app/models/dtos/obra-dto';
import { Capa } from 'src/app/models/entities/capa';
import { CapaService } from 'src/app/services/capa.service';
import { SegmentoService } from 'src/app/services/segmento.service';
import { Segmento } from 'src/app/models/entities/segmento';
import { LevantamientoSeleccionadoDTO } from 'src/app/models/dtos/levantamiento-seleccionado-dto';
import { Coordenada } from 'src/app/models/entities/coordenada';
import { CapaSegmentosDTO } from 'src/app/models/dtos/capa-segmentos-dto';
import { ArchivoCoordenada } from 'src/app/models/entities/archivo-coordenada';
import { ArchivoCoordenadaService } from 'src/app/services/archivo-coordenada.service';
import { KmlUtils } from 'src/app/shared/utils/kml-utils';
import { InteraccionMapaService } from 'src/app/services/interaccion-mapa.service';
import { AvanceDTO } from 'src/app/models/dtos/avance-dto';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InfoWindow } from '@agm/core/services/google-maps-types';
import { DateUtils } from 'src/app/shared/utils/date-utils';
import { Usuario } from 'src/app/models/entities/usuario';
import { UsuarioService } from 'src/app/services/usuario.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'detalle-obra',
  templateUrl: './detalle-obra.component.html',
  styleUrls: ['./detalle-obra.component.scss']
})
export class DetalleObraComponent implements OnInit {

  public readonly CAPA_PROYECTO_PROCESO: string = '0';
  public readonly CAPA_PROYECTO_PLANEACION: string = '4';
  public readonly CAPA_META_ACTUAL: string = '1';
  public readonly CAPA_COMPLETADO: string = '2';
  public readonly CAPA_ESTRUCTURA: string = '5';
  public readonly KEY_COLOR_CAPA_COMPLETADO: string = '2';
  public COLOR_PARA_RESALTAR: string = '#e80000';

  public levantamientosObrasFiltradas: LevantamientoObra[] = [];
  public mostrarMapaObras: boolean = false;
  public elementosObra: LevantamientoSeleccionadoDTO;
  public map: any;
  public mostrarProyecto: boolean = true;
  public mostrarAvance: boolean = true;
  public mostrarCompletado: boolean = true;
  public mostrarEstructuras: boolean = true;
  public mostrarPendiente: boolean = true;

  public catDireccionesAdjuntas: ElementoCatalogo[] = null;
  public catEstados: Estado[] = [];
  public catCapas: ElementoCatalogo[];
  public catSubElementos: ElementoCatalogo[];
  public catColores: ElementoCatalogo[];
  public catSecciones: ElementoCatalogo[];
  public catCarpetas: ElementoCatalogo[];
  public catTipoLevantamiento: ElementoCatalogo[];
  public catTipoObra: ElementoCatalogo[];

  @ViewChild('modalGaleria')
  public modalGaleria: NgbModalRef;
  public refModalGaleria: NgbModalRef;
  public avanceSeleccionado: AvanceDTO;

  public datosObra: LevantamientoSeleccionadoDTO;

  public iconoMultimedia: any = {
    url: '../../../../../assets/img/iconos/icono-multimedia.png',
    scaledSize: {
      width: 20,
      height: 20
    }
  };
  public iconoPuente: any = {
    url: '../../../../../assets/img/iconos/icono-puente.png',
    scaledSize: {
      width: 20,
      height: 20
    }
  };
  public iconoCoordenada: any = {
    url: '../../../../../assets/img/iconos/coordenada-disponible.png',
    scaledSize: {
      width: 5,
      height: 5
    }
  };

  public iconoInicioFin: any;

  public hexColorCapaCompletado: string = '';
  public coordenadaInicial: Coordenada;
  public coordenadaFinal: Coordenada;
  public coordenadaInfoWindow: Coordenada;
  public infoWindowActual: InfoWindow = null;
  public infoWindowAbierto = false;
  public valorCheckbox: boolean = true;
  public colorSegmentosSeleccionados: string = '';

  public suscripcionPolylines: Subscription;
  public archivosSeleccionados: ArchivoCoordenada[];

  public anioActual = new Date().getFullYear();

  public readonly CAMINOS_RURALES: string = '0';
  public readonly CARRETERAS_FEDERALES: string = '1';

  constructor(
    private catalogoService: CatalogoService,
    private mapUtils: MapUtils,
    private capaService: CapaService,
    private segmentoService: SegmentoService,
    private archivoCoordenadaService: ArchivoCoordenadaService,
    private ngbModalService: NgbModal,
    private cd: ChangeDetectorRef,
    private mapsAPILoader: MapsAPILoader,
    public dateUtils: DateUtils,
    private interaccionMapaService: InteraccionMapaService,
    private usuarioService: UsuarioService,
    private obraService: ObraService,
    private kmlUtils: KmlUtils,
    private loaderService: LoaderService
  ) { }

  async ngOnInit() {
    await this.obtenerCatalogos();
    this.interaccionMapaService.obtenerDatosObra().subscribe(
      (levantamientoObra: LevantamientoObra) => this.obtenerPolilynes(levantamientoObra)
    );
  }

  public async obtenerCatalogos(): Promise<any> {
    this.catDireccionesAdjuntas = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.DIRECCIONES_ADJUNTAS).pipe(take(1)).toPromise();
    this.catEstados = await this.catalogoService.obtenerCatalogo<Estado>(RutaCatalogoEnum.ESTADOS).pipe(take(1)).toPromise();
    this.catSubElementos = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.SUB_ELEMENTOS).pipe(take(1)).toPromise();
    this.catColores = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.COLORES).pipe(take(1)).toPromise();
    this.catCapas = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.CAPAS).pipe(take(1)).toPromise();
    this.catCarpetas = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.CARPETAS).pipe(take(1)).toPromise();
    this.catSecciones = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.SECCIONES).pipe(take(1)).toPromise();
    this.catTipoLevantamiento = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.TIPOS_LEVANTAMIENTOS).pipe(take(1)).toPromise();
    this.catTipoObra = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.TIPOS_OBRAS).pipe(take(1)).toPromise();
  }

  public async obtenerPolilynes(obraLevantamiento: LevantamientoObra) {
    await this.usuarioService.findByKey(obraLevantamiento.keyUsuarioLevantamiento).pipe(take(1),
      concatMap((usuarioLevantamiento: Usuario) => this.usuarioService.findByKey(obraLevantamiento.keyUsuarioAprobacion).pipe(take(1),
        map((usuarioAprobo: Usuario) => {
          let datosObra: LevantamientoSeleccionadoDTO = {};
          datosObra.direccionAdjunta = this.catDireccionesAdjuntas.find((direccionAdjunta: ElementoCatalogo) => direccionAdjunta.key === obraLevantamiento.keyCatDireccionAdjunta);
          datosObra.tipoObra = this.catTipoObra.find((tipoObra: ElementoCatalogo) => tipoObra.key === obraLevantamiento.keyCatTipoObra);
          datosObra.estado = this.catEstados.find((estado: Estado) => estado.key === obraLevantamiento.keyCatEstado);
          datosObra.tipoLevantamiento = this.catTipoLevantamiento.find((tipoLevantamiento: ElementoCatalogo) => tipoLevantamiento.key === obraLevantamiento.keyCatTipoLevantamiento);
          datosObra.usuarioAprobo = usuarioAprobo;
          datosObra.usuarioLevantamiento = usuarioLevantamiento;
          datosObra.levObra = obraLevantamiento;
          return datosObra;
        }),
        concatMap((levSelDTO: LevantamientoSeleccionadoDTO) => this.capaService.findByKeyLevantamientoObra(levSelDTO.levObra.key).pipe(take(1),
          concatMap((capas: Capa[]) => from(capas).pipe(
            concatMap((capa: Capa) => this.segmentoService.findByKeyCapa(capa.key).pipe(take(1),
              map((segmentos: Segmento[]) => {
                let longitudSegmentos: number = 0;
                segmentos.forEach((segmento: Segmento) => {
                  let path: Array<google.maps.LatLng> = Array.from(segmento.coordenadas, (c: Coordenada) => new google.maps.LatLng(c.latitud, c.longitud));
                  let longitudSegmento: number = google.maps.geometry.spherical.computeLength(path);
                  longitudSegmentos += parseFloat(longitudSegmento.toFixed(2));
                });
                let capaSegmentos: CapaSegmentosDTO = {
                  capa,
                  segmentos: segmentos.map((segmento: Segmento) => (
                    { ...segmento, nombreColor: this.catColores.find((e: ElementoCatalogo) => e.key === segmento.keyCatColor).nombre }
                  )),
                  nombreCapa: this.catCapas.find((e: ElementoCatalogo) => e.key === capa.keyCatCapa).nombre,
                  longitudSegmentos
                };
                return capaSegmentos;
              })
            )),
            toArray()
          )),
          map((capasSegmentos: CapaSegmentosDTO[]) =>
            ({
              ...levSelDTO,
              capasSegmentos
            } as LevantamientoSeleccionadoDTO)
          )
        )),
        concatMap((datosObraSeleccionada: LevantamientoSeleccionadoDTO) => this.archivoCoordenadaService.findByKeyLevantamientoObra(datosObraSeleccionada.levObra.key).pipe(take(1),
          map((archivos: ArchivoCoordenada[]) => {
            datosObraSeleccionada.capasSegmentos.forEach((capaSegmentos: CapaSegmentosDTO) => {
              capaSegmentos.segmentos.forEach((segmento: Segmento) => {
                segmento.coordenadas.forEach((coordenada: Coordenada, indice: number) => {
                  let archivosEncontrados: ArchivoCoordenada[] = archivos.filter((a: ArchivoCoordenada) => a.keySegmento === segmento.key && a.keyCoordenada === indice.toString());
                  if (archivosEncontrados.length > 0) {
                    coordenada.archivos = archivosEncontrados;
                  } else {
                    coordenada.archivos = [];
                  }
                });
              });
              capaSegmentos.mostrarCapa = true;
              switch (capaSegmentos.capa.keyCatCapa) {
                case this.CAPA_PROYECTO_PROCESO: capaSegmentos.zIndex = 10; break;
                case this.CAPA_PROYECTO_PLANEACION: capaSegmentos.zIndex = 10; break;
                case this.CAPA_META_ACTUAL: capaSegmentos.zIndex = 20; break;
                case this.CAPA_COMPLETADO: capaSegmentos.zIndex = 30; break;
                case this.CAPA_ESTRUCTURA: capaSegmentos.zIndex = 40; break;
              }
            });
            // Se crea el arreglo de avances. Cada avance tiene su propia fecha y un arreglo de segmentos. Se agrupan segmentos por fecha
            //  Ademas, ese arreglo de segmentos tiene un calculo con la suma de todas sus longitudes.
            let capaCompletado: CapaSegmentosDTO = datosObraSeleccionada.capasSegmentos.find((capaSegmentos: CapaSegmentosDTO) => capaSegmentos.capa.keyCatCapa === this.CAPA_COMPLETADO);
            let avances: AvanceDTO[] = [];
            if (capaCompletado) {
              let mapaFechas = new Map<number, Segmento[]>();
              capaCompletado.segmentos.forEach((segmento: Segmento) => {
                let segmentos: Segmento[] = mapaFechas.get(segmento.fechaRegistro ? segmento.fechaRegistro : segmento.fechaCreacion);
                if (!segmentos) {
                  segmentos = [];
                }
                segmentos.push(segmento);
                mapaFechas.set(segmento.fechaRegistro ? segmento.fechaRegistro : segmento.fechaCreacion, segmentos);
              });

              mapaFechas.forEach((segmentos: Segmento[], fecha: number) => {
                let longitudSegmentos: number = 0;
                segmentos.forEach((segmento: Segmento) => {
                  let path: Array<google.maps.LatLng> = Array.from(segmento.coordenadas, (c: Coordenada) => new google.maps.LatLng(c.latitud, c.longitud));
                  let longitudSegmento: number = google.maps.geometry.spherical.computeLength(path);
                  longitudSegmentos += parseFloat(longitudSegmento.toFixed(2));
                });

                let avance: AvanceDTO = {
                  capa: capaCompletado.capa,
                  nombreCapa: capaCompletado.nombreCapa,
                  zIndex: capaCompletado.zIndex,
                  mostrarCapa: capaCompletado.mostrarCapa,
                  fecha,
                  segmentos,
                  longitudSegmentos
                };

                avances.push(avance);
              });
            }
            datosObraSeleccionada.avances = avances;

            return datosObraSeleccionada;
          })
        )),
        concatMap((datosObraSeleccionada: LevantamientoSeleccionadoDTO) => this.obraService.findByKeyLevantamientoObra(datosObraSeleccionada.levObra.key).pipe(
          take(1),
          map((obra: Obra) => ({
            ...datosObraSeleccionada,
            obra
          } as LevantamientoSeleccionadoDTO))
        )),
        take(1)
      ))
    ).toPromise().then(
      (datosObraSeleccionada: LevantamientoSeleccionadoDTO) => {
        this.elementosObra = datosObraSeleccionada;
        this.mostrarMapaObras = true;
        this.loaderService.desactivarLoaderScreen();
      }
    );
  }

  async ngOnChanges(): Promise<void> {
    await this.mapsAPILoader.load();
    if (this.map) {//Se valida que el mapa este pintado en pantalla para poder centrar las polylines
      this.mapUtils.centrarArregloDePolylines(this.map, this.crearArregloPolylines(this.elementosObra.capasSegmentos));
    }
    this.iconoInicioFin = {
      url: '../../../../../assets/img/iconos/marker-red.png',
      scaledSize: {
        width: 25,
        height: 25
      },
      labelOrigin: new google.maps.Point(0, 0)
    };
    this.cd.detectChanges();
  }

  public obtenerNombreCarpeta(keyCatCarpeta: string): string {
    return this.catCarpetas.find((carpeta: ElementoCatalogo) => carpeta.key === keyCatCarpeta).nombre;
  }

  public obtenerNombreSeccion(keyCatSeccion: string): string {
    return this.catSecciones.find((seccion: ElementoCatalogo) => seccion.key === keyCatSeccion).nombre;
  }

  public async descargarKMLPersonalizado(obra: Obra) {
    this.datosObra = await this.capaService.findByKeyLevantamientoObra(obra.keyLevantamientoObra).pipe(
      take(1),
      concatMap((capas: Capa[]) => from(capas).pipe(
        concatMap((capa: Capa) => this.segmentoService.findByKeyCapa(capa.key).pipe(take(1))
        ))
      ),
      take(1)
    ).toPromise();
    this.kmlUtils.descargarKml(this.datosObra[0].coordenadas);
  }

  public abrirModalGaleria(archivosSeleccionados: ArchivoCoordenada[]) {
    this.archivosSeleccionados = archivosSeleccionados;
    this.refModalGaleria = this.ngbModalService.open(this.modalGaleria, {
      size: 'lg',
      centered: true,
      windowClass: 'modal-lev-web',
      backdrop: 'static',
      keyboard: false
    });
  }

  public centrarMapa() {
    this.mapUtils.centrarArregloDePolylines(this.map, this.crearArregloPolylines(this.elementosObra.capasSegmentos));
  }

  public mouseOver(event: any, infoWindow: InfoWindow, avance: AvanceDTO): any {
    this.coordenadaInfoWindow = {
      latitud: event.latLng.lat(),
      longitud: event.latLng.lng()
    };
    if (this.infoWindowActual && this.infoWindowAbierto) {
      this.infoWindowActual.close();
    }
    this.infoWindowActual = infoWindow;
    infoWindow.open();
    this.infoWindowAbierto = true;
    this.colorSegmentosSeleccionados = this.COLOR_PARA_RESALTAR;
    setTimeout(() => {
      this.avanceSeleccionado = avance;
      this.cd.detectChanges();
    }, 10);
  }


  public infoWindowClose(): void {
    if (this.avanceSeleccionado && this.infoWindowAbierto) {
      this.colorSegmentosSeleccionados = this.hexColorCapaCompletado;
    }
    this.avanceSeleccionado = null;
    this.infoWindowAbierto = false;
    setTimeout(() => {
      this.cd.detectChanges();
    }, 10);
  }


  public onPropertyChange(valor: boolean, keyCatCapa: string): void {
    if (keyCatCapa === this.CAPA_COMPLETADO) {
      this.elementosObra.avances.forEach((avance: AvanceDTO) => {
        avance.mostrarCapa = valor;
      });
    }

    this.elementosObra.capasSegmentos.forEach((capaSegmentos: CapaSegmentosDTO) => {
      if (capaSegmentos.capa.keyCatCapa === keyCatCapa) {
        capaSegmentos.mostrarCapa = valor;
      }
    });

  }
  public mapReady(event: any): void {
    this.map = event;
    this.mapUtils.centrarArregloDePolylines(this.map, this.crearArregloPolylines(this.elementosObra.capasSegmentos));
    this.coordenadaInicial = this.mapUtils.obtenerCoordenadaInicialArregloPolylines(this.crearArregloPolylineProyecto());
    this.coordenadaFinal = this.mapUtils.obtenerCoordenadaFinalArregloPolylines(this.crearArregloPolylineProyecto());
  }

  public crearArregloPolylines(capasSegmentos: CapaSegmentosDTO[]): any {
    let coordenadas: Array<Coordenada[]> = new Array<Coordenada[]>();
    capasSegmentos.forEach((capaSegmento) => {
      capaSegmento.segmentos.forEach((segmento: Segmento) => {
        coordenadas.push(segmento.coordenadas)
      });
    });
    return coordenadas.map((coordenadas: Coordenada[]) => this.crearPolyline(coordenadas))
  }

  public crearArregloPolylineProyecto(): Array<Coordenada[]> {
    let capaProyecto: CapaSegmentosDTO = this.elementosObra.capasSegmentos.find((capa: CapaSegmentosDTO) => capa.capa.keyCatCapa === this.CAPA_PROYECTO_PROCESO || capa.capa.keyCatCapa === this.CAPA_PROYECTO_PLANEACION)
    let segmentos: Array<Coordenada[]> = capaProyecto.segmentos.map((segmento: Segmento) => segmento.coordenadas);
    return segmentos;
  }

  public crearPolyline(points: Coordenada[]): any {
    return {
      googlePolylinePoints: points.map(p => ({ lat: p.latitud, lng: p.longitud }))
    };
  }

  public cambiarCapaFederales(nombreCapa: string) {
    if (this.elementosObra.direccionAdjunta.key === this.CARRETERAS_FEDERALES) {
      if (nombreCapa === 'Completado') {
        return 'Terminado';
      } else if (nombreCapa === 'Meta actual') {
        return `Programado ${this.anioActual}`;
      } else {
        return nombreCapa;
      }
    } else {
      return nombreCapa;
    }
  }

  public ngOnDestroy(): void {
    if (this.suscripcionPolylines) {
      this.suscripcionPolylines.unsubscribe();
    }
  }

}